import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const AaliMovies = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('visible'); });
    }, { threshold: 0.2 });
    document.querySelectorAll('.scroll-reveal, .service-item, .info-card').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className="company-hero" style={{ background: 'linear-gradient(135deg, #6a040f, #9d0208)' }}>
        <div className="hero-content">
          <h1>AALI MOVIES</h1>
          <p>Film production house creating compelling cinema that entertains and inspires audiences worldwide</p>
        </div>
      </div>
      <div className="company-content">
        <div className="container">
          <div className="company-grid">
            <div className="left scroll-reveal">
              <h2>About AALI MOVIES</h2>
              <p>AALI MOVIES is dedicated to producing high-quality films that resonate with diverse audiences. From blockbuster entertainment to thought-provoking narratives, we bring stories to life on the big screen.</p>
              <h3>Our Services</h3>
              <div className="services-list">
                <div className="service-item"><span>✔</span> Film Production</div>
                <div className="service-item"><span>✔</span> Content Development</div>
                <div className="service-item"><span>✔</span> Distribution</div>
                <div className="service-item"><span>✔</span> Post-Production Services</div>
                <div className="service-item"><span>✔</span> Talent Management</div>
              </div>
            </div>
            <div className="info-card scroll-reveal">
              <h4>Company Info</h4>
              <div className="info-block">
                <span className="info-label">Industry</span>
                <strong className="info-value">Media & Entertainment</strong>
              </div>
              <div className="info-block">
                <span className="info-label">Parent Company</span>
                <strong className="info-value">AALI GROUP</strong>
              </div>
              <div className="actions">
                <Link to="/contact" className="btn-primary">Get in Touch</Link>
                <Link to="/coming-soon" className="btn-primary">Visit Main Website</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AaliMovies;